import { render, staticRenderFns } from "./ConfirmCandidateAllocationAction.vue?vue&type=template&id=60f54cbe&"
import script from "./ConfirmCandidateAllocationAction.vue?vue&type=script&lang=js&"
export * from "./ConfirmCandidateAllocationAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports